import React, { useEffect, useState } from 'react'
import { FormLabel, Card } from "@mui/material";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import TableData from './TableData';
import { useGlobalcontext } from './context';
import { toast } from 'react-toastify';
const InputsIcon = () => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="15" width="15" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
);

const InletsIcon = () => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="15" width="15" xmlns="http://www.w3.org/2000/svg">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
  </svg>
);

const OutletsIcon = () => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="15" width="15" xmlns="http://www.w3.org/2000/svg">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" transform="rotate(180 12 12)"></polygon>
  </svg>
);



const CustomSelect = ({ id, value, options, onChange, name, openDropdown, setOpenDropdown }) => {
  const isOpen = openDropdown === id;
  const selectedOption = options.find(opt => opt.value === value);

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpenDropdown(isOpen ? null : id);
  };

  const handleSelect = (val, e) => {
    e.stopPropagation();
    onChange(val, name);
    setOpenDropdown(null);
  };

  return (
    <div className="custom-select-container" onClick={(e) => e.stopPropagation()}>
      <div 
        className={`custom-select-trigger ${isOpen ? 'active' : ''}`} 
        onClick={handleToggle}
      >
        <span>{selectedOption ? selectedOption.label : value}</span>
        <span className="custom-select-arrow">
          {isOpen ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </div>
      
      {isOpen && (
        <div className="custom-select-options">
          {options.map((opt) => (
            <div 
              key={opt.value} 
              className={`custom-select-option ${value === opt.value ? 'selected' : ''}`}
              onClick={(e) => handleSelect(opt.value, e)}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Sidepanel = ({ setRes, setBtnsDisable }) => {
  const { formData, setFormData, setPartname, setObjdata, setMaterial, setHighlightingText, setShadowVisible, inletuuids, objdata, outletuuids, setOutletuuids, setInletuuids, material } = useGlobalcontext()
  const [firstdropdown, setFirstDropdown] = useState(false)
  const [seconddropdown, setSecondDropdown] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleOutsideClick = () => {
      setOpenDropdown(null);
    };
    window.addEventListener('click', handleOutsideClick);
    return () => window.removeEventListener('click', handleOutsideClick);
  }, []);

  const materialOptions = [
    { value: "Carbon Steel", label: "Carbon Steel" },
    { value: "Stainless Steel", label: "Stainless Steel" }
  ];

  const diameterOptions = [
    { value: 200, label: "200" },
    { value: 300, label: "300" }
  ];

  const lengthOptions = [2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000].map(val => ({
    value: val,
    label: val.toString()
  }));

  const qtyOptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" }
  ];

  const [inputfirstvalue, setInputFirstValue] = useState(0)
  const [inputsecondvalue, setInputsecondValue] = useState(322)
  const [inputthirdvalue, setInputThirdValue] = useState(644)
  const [ouletfirstvalue, setOutletFirstValue] = useState(0)
  const [ouletsecondvalue, setOutletSecondValue] = useState(252)
  const [ouletthirdvalue, setOutletThirdValue] = useState(504)


  const FirstDropDown = () => {
    setFirstDropdown(!firstdropdown)
    setSecondDropdown(false)
  }
  const SecondDropdown = () => {
    setSecondDropdown(!seconddropdown)
    setFirstDropdown(false)
  }




  useEffect(() => {
    if (formData.diameter == 200) {
      setInputFirstValue(0);
      setInputsecondValue(322);
      setInputThirdValue(644);
      setOutletFirstValue(0);
      setOutletSecondValue(252);
      setOutletThirdValue(504);
      setFormData((prop) => ({
        ...prop,
        inletp1: 0,
        inletp2: 322,
        inletp3: 644,
        outletp1: 0,
        outletp2: 252,
        outletp3: 504
      }))
    } else {
      setInputFirstValue(0);
      setInputsecondValue(422);
      setInputThirdValue(844);
      setOutletFirstValue(0);
      setOutletSecondValue(352);
      setOutletThirdValue(704);
      setFormData((prop) => ({
        ...prop,
        inletp1: 0,
        inletp2: 422,
        inletp3: 844,
        outletp1: 0,
        outletp2: 352,
        outletp3: 704
      }))
    }

  }, [formData.diameter, formData.length])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    toast.dismiss();
    setBtnsDisable(false)
    setRes('')
    if (name === "length" || name === "diameter") {
      setPartname('');
      setShadowVisible(true);
      setObjdata([]);
      setInletuuids([]);
      setOutletuuids([]);
      setHighlightingText('')
    }



    if (name === "inletqty" && inletuuids.length > 0) {
      inletuuids.forEach((item) => {
        setObjdata((prev) => prev.filter((obj) => obj.uuid !== item));
      });
    }

    if (name === "outletqty" && outletuuids.length > 0) {
      outletuuids.forEach((item) => {
        setObjdata((prev) => prev.filter((obj) => obj.uuid !== item));
      });
    }


    setFormData((prev) => ({
      ...prev,
      [name]: value === '' || isNaN(Number(value)) ? 0 : Number(value),
    }));
  };




  const getMinMaxValues = (length, diameter) => {
    if (diameter == 200) {
      switch (length) {
        case 2000:
          return {
            inletp1: { min: 0, max: 1698 },
            inletp2: { min: 322, max: 1698 },
            inletp3: { min: 644, max: 1698 },
            outletp1: { min: 0, max: 1768 },
            outletp2: { min: 252, max: 1768 },
            outletp3: { min: 504, max: 1768 },
          };
        case 3000:
          return {
            inletp1: { min: 0, max: 2698 },
            inletp2: { min: 322, max: 2698 },
            inletp3: { min: 644, max: 2698 },
            outletp1: { min: 0, max: 2768 },
            outletp2: { min: 252, max: 2768 },
            outletp3: { min: 504, max: 2768 },
          };
        case 4000:
          return {
            inletp1: { min: 0, max: 3698 },
            inletp2: { min: 322, max: 3698 },
            inletp3: { min: 644, max: 3698 },
            outletp1: { min: 0, max: 3768 },
            outletp2: { min: 252, max: 3768 },
            outletp3: { min: 504, max: 3768 },
          };
        case 5000:
          return {
            inletp1: { min: 0, max: 4698 },
            inletp2: { min: 322, max: 4698 },
            inletp3: { min: 644, max: 4698 },
            outletp1: { min: 0, max: 4768 },
            outletp2: { min: 252, max: 4768 },
            outletp3: { min: 504, max: 4768 },
          };
        case 6000:
          return {
            inletp1: { min: 0, max: 5698 },
            inletp2: { min: 322, max: 5698 },
            inletp3: { min: 644, max: 5698 },
            outletp1: { min: 0, max: 5768 },
            outletp2: { min: 252, max: 5768 },
            outletp3: { min: 504, max: 5768 },
          };
        case 7000:
          return {
            inletp1: { min: 0, max: 6698 },
            inletp2: { min: 322, max: 6698 },
            inletp3: { min: 644, max: 6698 },
            outletp1: { min: 0, max: 6768 },
            outletp2: { min: 252, max: 6768 },
            outletp3: { min: 504, max: 6768 },
          };
        case 8000:
          return {
            inletp1: { min: 0, max: 7698 },
            inletp2: { min: 322, max: 7698 },
            inletp3: { min: 644, max: 7698 },
            outletp1: { min: 0, max: 7768 },
            outletp2: { min: 252, max: 7768 },
            outletp3: { min: 504, max: 7768 },
          };
        case 9000:
          return {
            inletp1: { min: 0, max: 8698 },
            inletp2: { min: 322, max: 8698 },
            inletp3: { min: 644, max: 8698 },
            outletp1: { min: 0, max: 8768 },
            outletp2: { min: 252, max: 8768 },
            outletp3: { min: 504, max: 8768 },
          };
        case 10000:
          return {
            inletp1: { min: 0, max: 9698 },
            inletp2: { min: 322, max: 9698 },
            inletp3: { min: 644, max: 9698 },
            outletp1: { min: 0, max: 9768 },
            outletp2: { min: 252, max: 9768 },
            outletp3: { min: 504, max: 9768 },
          };
        case 11000:
          return {
            inletp1: { min: 0, max: 10698 },
            inletp2: { min: 322, max: 10698 },
            inletp3: { min: 644, max: 10698 },
            outletp1: { min: 0, max: 10768 },
            outletp2: { min: 252, max: 10768 },
            outletp3: { min: 504, max: 10768 },
          };
        case 12000:
          return {
            inletp1: { min: 0, max: 11698 },
            inletp2: { min: 322, max: 11698 },
            inletp3: { min: 644, max: 11698 },
            outletp1: { min: 0, max: 11768 },
            outletp2: { min: 252, max: 11768 },
            outletp3: { min: 504, max: 11768 },
          };
        default:
          return {};
      }
    }
    else {
      switch (length) {
        case 2000:
          return {
            inletp1: { min: 0, max: 1598 },
            inletp2: { min: 422, max: 1598 },
            inletp3: { min: 844, max: 1598 },
            outletp1: { min: 0, max: 1668 },
            outletp2: { min: 352, max: 1668 },
            outletp3: { min: 704, max: 1668 },
          };
        case 3000:
          return {
            inletp1: { min: 0, max: 2598 },
            inletp2: { min: 422, max: 2598 },
            inletp3: { min: 844, max: 2598 },
            outletp1: { min: 0, max: 2668 },
            outletp2: { min: 352, max: 2668 },
            outletp3: { min: 704, max: 2668 },
          };
        case 4000:
          return {
            inletp1: { min: 0, max: 3598 },
            inletp2: { min: 422, max: 3598 },
            inletp3: { min: 844, max: 3598 },
            outletp1: { min: 0, max: 3668 },
            outletp2: { min: 352, max: 3668 },
            outletp3: { min: 704, max: 3668 },
          };
        case 5000:
          return {
            inletp1: { min: 0, max: 4598 },
            inletp2: { min: 422, max: 4598 },
            inletp3: { min: 844, max: 4598 },
            outletp1: { min: 0, max: 4668 },
            outletp2: { min: 352, max: 4668 },
            outletp3: { min: 704, max: 4668 },
          };
        case 6000:
          return {
            inletp1: { min: 0, max: 5598 },
            inletp2: { min: 422, max: 5598 },
            inletp3: { min: 844, max: 5598 },
            outletp1: { min: 0, max: 5668 },
            outletp2: { min: 352, max: 5668 },
            outletp3: { min: 704, max: 5668 },
          };
        case 7000:
          return {
            inletp1: { min: 0, max: 6598 },
            inletp2: { min: 422, max: 6598 },
            inletp3: { min: 844, max: 6598 },
            outletp1: { min: 0, max: 6668 },
            outletp2: { min: 352, max: 6668 },
            outletp3: { min: 704, max: 6668 },
          };
        case 8000:
          return {
            inletp1: { min: 0, max: 7598 },
            inletp2: { min: 422, max: 7598 },
            inletp3: { min: 844, max: 7598 },
            outletp1: { min: 0, max: 7668 },
            outletp2: { min: 352, max: 7668 },
            outletp3: { min: 704, max: 7668 },
          };
        case 9000:
          return {
            inletp1: { min: 0, max: 8598 },
            inletp2: { min: 422, max: 8598 },
            inletp3: { min: 844, max: 8598 },
            outletp1: { min: 0, max: 8668 },
            outletp2: { min: 352, max: 8668 },
            outletp3: { min: 704, max: 8668 },
          };
        case 10000:
          return {
            inletp1: { min: 0, max: 9598 },
            inletp2: { min: 422, max: 9598 },
            inletp3: { min: 844, max: 9598 },
            outletp1: { min: 0, max: 9668 },
            outletp2: { min: 352, max: 9668 },
            outletp3: { min: 704, max: 9668 },
          };
        case 11000:
          return {
            inletp1: { min: 0, max: 10598 },
            inletp2: { min: 422, max: 10598 },
            inletp3: { min: 844, max: 10598 },
            outletp1: { min: 0, max: 10668 },
            outletp2: { min: 352, max: 10668 },
            outletp3: { min: 704, max: 10668 },
          };
        case 12000:
          return {
            inletp1: { min: 0, max: 11598 },
            inletp2: { min: 422, max: 11598 },
            inletp3: { min: 844, max: 11598 },
            outletp1: { min: 0, max: 11668 },
            outletp2: { min: 352, max: 11668 },
            outletp3: { min: 704, max: 11668 },
          };
        default:
          return {};
      }
    }
  };
  const currentinputsdata = getMinMaxValues(formData.length, formData.diameter)


  // inlets   onChange events 
  const firstInlethandleChange = (e) => {
    const { value } = e.target
    toast.dismiss()
    setInputFirstValue(value)
    setBtnsDisable(false)
    setRes('')
    setFormData((prev) => ({
      ...prev,
      inletp1: value
    }));
    if (value < currentinputsdata.inletp1.min) {
      setFormData((prev) => ({
        ...prev,
        inletp1: currentinputsdata.inletp1.min
      }));
      toast(`Inlet Position 1 ranges between ${currentinputsdata.inletp1.min} mm to ${currentinputsdata.inletp1.max} mm`)

    }
    if (value > currentinputsdata.inletp1.max) {
      setFormData((prev) => ({
        ...prev,
        inletp1: currentinputsdata.inletp1.max
      }));
      toast(`Inlet Position 1 ranges between ${currentinputsdata.inletp1.min} mm to ${currentinputsdata.inletp1.max} mm`)
    }


  }



  const secondInlethandleChange = (e) => {
    const { value } = e.target
    if (formData.inletqty === 2 || formData.inletqty === 3) {
      toast.dismiss()
      setInputsecondValue(value)
      setBtnsDisable(false)
      setRes('')
      setFormData((prev) => ({
        ...prev,
        inletp2: value
      }));
      if (value < currentinputsdata.inletp2.min) {
        setFormData((prev) => ({
          ...prev,
          inletp2: currentinputsdata.inletp2.min
        }));
        toast(`Inlet Position 2 ranges between ${currentinputsdata.inletp2.min} mm to ${currentinputsdata.inletp2.max} mm`);
      }
      if (value > currentinputsdata.inletp2.max) {
        setFormData((prev) => ({
          ...prev,
          inletp2: currentinputsdata.inletp2.max
        }));
        toast(`Inlet Position 2 ranges between ${currentinputsdata.inletp2.min} mm to ${currentinputsdata.inletp2.max} mm`);

      }
    }



  }


  const thirdInlethandleChange = (e) => {
    const { value } = e.target
    if (formData.inletqty === 3) {
      setBtnsDisable(false)
      setRes('')
      toast.dismiss()
      setInputThirdValue(value)
      setFormData((prev) => ({
        ...prev,
        inletp3: value
      }));
      if (value < currentinputsdata.inletp3.min) {
        setFormData((prev) => ({
          ...prev,
          inletp3: currentinputsdata.inletp3.min
        }));
        toast(`Inlet Position 3 ranges between ${currentinputsdata.inletp3.min} mm to ${currentinputsdata.inletp3.max} mm`);

      }
      if (value > currentinputsdata.inletp3.max) {
        setFormData((prev) => ({
          ...prev,
          inletp3: currentinputsdata.inletp3.max
        }));
        toast(`Inlet Position 3 ranges between ${currentinputsdata.inletp3.min} mm to ${currentinputsdata.inletp3.max} mm`);
      }
    }


  }

  // outlets onChange events 

  const firstOutletHandleChange = (e) => {
    const { value } = e.target
    toast.dismiss()
    setBtnsDisable(false)
    setRes('')
    setOutletFirstValue(value)
    setFormData((prev) => ({
      ...prev,
      outletp1: value
    }));
    if (value < currentinputsdata.outletp1.min) {
      setFormData((prev) => ({
        ...prev,
        outletp1: currentinputsdata.outletp1.min
      }));
      toast(`Outlet Position 1 ranges between ${currentinputsdata.outletp1.min} mm to ${currentinputsdata.outletp1.max} mm`)

    }
    if (value > currentinputsdata.outletp1.max) {
      setFormData((prev) => ({
        ...prev,
        outletp1: currentinputsdata.outletp1.max
      }));
      toast(`Outlet Position 1 ranges between ${currentinputsdata.outletp1.min} mm to ${currentinputsdata.outletp1.max} mm`)
    }

  }

  const secondOutletHandleChange = (e) => {
    const { value } = e.target
    if (formData.outletqty == 2 || formData.outletqty == 3) {
      setBtnsDisable(false)
      setRes('')
      toast.dismiss()
      setOutletSecondValue(value)
      setFormData((prev) => ({
        ...prev,
        outletp2: value
      }));
      if (value < currentinputsdata.outletp2.min) {
        setFormData((prev) => ({
          ...prev,
          outletp2: currentinputsdata.outletp2.min
        }));
        toast(`Outlet Position 2 ranges between ${currentinputsdata.outletp2.min} mm to ${currentinputsdata.outletp2.max} mm`)

      }
      if (value > currentinputsdata.outletp2.max) {
        setFormData((prev) => ({
          ...prev,
          outletp2: currentinputsdata.outletp2.max
        }));
        toast(`Outlet Position 2 ranges between ${currentinputsdata.outletp2.min} mm to ${currentinputsdata.outletp2.max} mm`)
      }
    }
  }

  const thirdOutletHandleChange = (e) => {
    const { value } = e.target
    if (formData.outletqty == 3) {
      setBtnsDisable(false)
      setRes('')
      toast.dismiss()
      setOutletThirdValue(value)
      setFormData((prev) => ({
        ...prev,
        outletp3: value
      }));
      if (value < currentinputsdata.outletp3.min) {
        setFormData((prev) => ({
          ...prev,
          outletp3: currentinputsdata.outletp3.min
        }));
        toast(`Outlet Position 3 ranges between ${currentinputsdata.outletp3.min} mm to ${currentinputsdata.outletp3.max} mm`)

      }
      if (value > currentinputsdata.outletp3.max) {
        setFormData((prev) => ({
          ...prev,
          outletp3: currentinputsdata.outletp3.max
        }));
        toast(`Outlet Position 3 ranges between ${currentinputsdata.outletp3.min} mm to ${currentinputsdata.outletp3.max} mm`)
      }
    }
  }


  const handleMaterialChange = (e) => {
    const selectedMaterial = e.target.value;
    setMaterial(selectedMaterial);
    setBtnsDisable(false)
    setRes('')
    setPartname("")
    setHighlightingText('')

    // if (partname == "Trough Section 2000 Ø200 Rotor Carbon Steel" || partname == "Trough Section 2000 Ø200 Rotor Stainless Steel" ||
    //   partname == "Trough Section 2000 Ø300 Rotor Carbon Steel" || partname == "Trough Section 2000 Ø300 Rotor Stainless Steel" ||
    //   partname == "Trough Section 3000 Ø200 Rotor Carbon Steel" || partname == "Trough Section 3000 Ø200 Rotor Stainless Steel" ||
    //   partname == "Trough Section 3000 Ø300 Rotor Carbon Steel" || partname == "Trough Section 3000 Ø300 Rotor Stainless Steel") {
    //   setPartname("")
    // }
  };


  return (
    <div className='sidebar panel' style={{ position: "relative" }}>
      <div className="sidebarcontent" style={{ overflow: "auto" }} >
        <div className='sidebarcards' >
          <div className="cards">

            {/* Inputs Card */}
            <div className="sidebar-card" style={{ zIndex: (openDropdown === 'material' || openDropdown === 'diameter' || openDropdown === 'length') ? 100 : 1 }}>
              <div className="sidebar-card-header" style={{ cursor: "default" }}>
                <div className="sidebar-card-header-left">
                  <div className="sidebar-card-icon-container">
                    <InputsIcon />
                  </div>
                  <div className="sidebar-card-title-group">
                    <h4 className="sidebar-card-title">Inputs</h4>
                    <span className="sidebar-card-subtitle">Core mechanical specification</span>
                  </div>
                </div>
              </div>
              <div className="sidebar-card-body">
                <div className="form-group">
                  <label>Rotor Material</label>
                  <CustomSelect
                    id="material"
                    value={material}
                    options={materialOptions}
                    onChange={(val) => handleMaterialChange({ target: { value: val } })}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                  />
                </div>
                <div className="form-grid-2">
                  <div className="form-group">
                    <label>Diameter (mm)</label>
                    <CustomSelect
                      id="diameter"
                      value={formData.diameter}
                      options={diameterOptions}
                      name="diameter"
                      onChange={(val, name) => handleInputChange({ target: { name, value: val } })}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    />
                  </div>
                  <div className="form-group">
                    <label>Length</label>
                    <CustomSelect
                      id="length"
                      value={formData.length}
                      options={lengthOptions}
                      name="length"
                      onChange={(val, name) => handleInputChange({ target: { name, value: val } })}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Inlets Card */}
            <div className="sidebar-card" style={{ zIndex: openDropdown === 'inletqty' ? 100 : 1 }}>
              <div className="sidebar-card-header" onClick={FirstDropDown}>
                <div className="sidebar-card-header-left">
                  <div className="sidebar-card-icon-container">
                    <InletsIcon />
                  </div>
                  <div className="sidebar-card-title-group">
                    <h4 className="sidebar-card-title">Inlets</h4>
                    <span className="sidebar-card-subtitle">Material entry points</span>
                  </div>
                </div>
                <div className="sidebar-card-header-right">
                  <div className="sidebar-card-badge">{formData.inletqty}</div>
                  <div className="sidebar-card-chevron">
                    {firstdropdown ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </div>
              </div>
              {firstdropdown && (
                <div className="sidebar-card-body">
                  <div className="form-group">
                    <label>Number of Inlets</label>
                    <CustomSelect
                      id="inletqty"
                      value={formData.inletqty}
                      options={qtyOptions}
                      name="inletqty"
                      onChange={(val, name) => handleInputChange({ target: { name, value: val } })}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    />
                  </div>

                  <div className="form-grid-2">
                    <div className="form-group">
                      <label>Position 1</label>
                      <div className="input-container-badge">
                        <input type="number" className="input" name="inputfirstvalue" value={inputfirstvalue} onChange={firstInlethandleChange} />
                        <span className="input-unit-badge">mm</span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Position 2</label>
                      <div className="input-container-badge">
                        <input type="number" className="input" name="inputsecondvalue" value={inputsecondvalue} onChange={secondInlethandleChange} />
                        <span className="input-unit-badge">mm</span>
                      </div>
                    </div>
                    <div className="form-group form-grid-2-span-2">
                      <label>Position 3</label>
                      <div className="input-container-badge">
                        <input type="number" className="input" name="inputthirdvalue" value={inputthirdvalue} onChange={thirdInlethandleChange} />
                        <span className="input-unit-badge">mm</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Outlets Card */}
            <div className="sidebar-card" style={{ zIndex: openDropdown === 'outletqty' ? 100 : 1 }}>
              <div className="sidebar-card-header" onClick={SecondDropdown}>
                <div className="sidebar-card-header-left">
                  <div className="sidebar-card-icon-container">
                    <OutletsIcon />
                  </div>
                  <div className="sidebar-card-title-group">
                    <h4 className="sidebar-card-title">Outlets</h4>
                    <span className="sidebar-card-subtitle">Material discharge points</span>
                  </div>
                </div>
                <div className="sidebar-card-header-right">
                  <div className="sidebar-card-badge">{formData.outletqty}</div>
                  <div className="sidebar-card-chevron">
                    {seconddropdown ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </div>
              </div>
              {seconddropdown && (
                <div className="sidebar-card-body">
                  <div className="form-group">
                    <label>Number of Outlets</label>
                    <CustomSelect
                      id="outletqty"
                      value={formData.outletqty}
                      options={qtyOptions}
                      name="outletqty"
                      onChange={(val, name) => handleInputChange({ target: { name, value: val } })}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                    />
                  </div>

                  <div className="form-grid-2">
                    <div className="form-group">
                      <label>Position 1</label>
                      <div className="input-container-badge">
                        <input type="number" className="input" name="outletp1" value={ouletfirstvalue} onChange={firstOutletHandleChange} />
                        <span className="input-unit-badge">mm</span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Position 2</label>
                      <div className="input-container-badge">
                        <input type="number" className="input" name="outletp2" value={ouletsecondvalue} onChange={secondOutletHandleChange} />
                        <span className="input-unit-badge">mm</span>
                      </div>
                    </div>
                    <div className="form-group form-grid-2-span-2">
                      <label>Position 3</label>
                      <div className="input-container-badge">
                        <input type="number" className="input" name="outletp3" value={ouletthirdvalue} onChange={thirdOutletHandleChange} />
                        <span className="input-unit-badge">mm</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <TableData />
          </div>

        </div>
      </div>
    </div>
  )
}

export default Sidepanel